// extracted by mini-css-extract-plugin
export default {"productGrid":"W1-z","centerLink":"X1-z","productSection":"Y1-z","item":"Z1-z","ctaButton":"_1-z"};